/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ESearchStatutInscription {
    None = 'None',
    Waiting = 'Waiting',
    Current = 'Current'
}


export function ESearchStatutInscriptionFromJSON(json: any): ESearchStatutInscription {
    return ESearchStatutInscriptionFromJSONTyped(json, false);
}

export function ESearchStatutInscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ESearchStatutInscription {
    return json as ESearchStatutInscription;
}

export function ESearchStatutInscriptionToJSON(value?: ESearchStatutInscription | null): any {
    return value as any;
}

